import { ControlledSelectField } from 'components/Form';
import { requiredBaseRule } from 'utils/constants';

import { useMemo } from 'react';
import type { UseControllerProps } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { useSeasons } from '../hooks/useSeasons';

export const getActKC2SeasonLabel = (year: number) => `Сезон ${year}`;

export const getActKC2SeasonItem = ({ id, year }: any) => ({
    id,
    label: getActKC2SeasonLabel(year),
});

export const ActKC2SeasonField = ({ name, control, disabled }: UseControllerProps & { disabled: boolean }) => {
    const { orderId } = useParams();
    const [seasons] = useSeasons(Number(orderId), true, 'actSeasons');

    const statusItems = useMemo(
        () =>
            seasons.map(({ id, year }: any) => ({
                id,
                label: getActKC2SeasonLabel(year),
            })),
        [seasons],
    );

    return (
        <ControlledSelectField
            disabled={disabled}
            name={name}
            label="Сезон"
            control={control}
            items={statusItems}
            required={!disabled}
            rules={requiredBaseRule}
        />
    );
};

ActKC2SeasonField.displayName = 'ActKC2SeasonField';
